import { render, staticRenderFns } from "./VincularTabelaOperadora.vue?vue&type=template&id=10aef26b&"
import script from "./VincularTabelaOperadora.vue?vue&type=script&lang=js&"
export * from "./VincularTabelaOperadora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports